import { LearnMoreIconIllustration } from "@/components/illustrations/learn-more-icon-illustration";

interface LearnMoreCardProps {
  description: string;
  href?: string;
  onClick?: () => void;
}

export function LearnMoreCard({
  description,
  href,
  onClick,
}: LearnMoreCardProps) {
  const card = (
    <div className="bg-contrast/3 border border-border rounded-lg px-3 py-2.5 w-[290px] hover:bg-contrast/5 transition-colors">
      <div className="flex gap-3 items-center w-full">
        <div className="border border-border rounded-md overflow-clip shrink-0 size-8">
          <LearnMoreIconIllustration />
        </div>
        <p className="text-[13px] font-normal text-heading tracking-[-0.26px] leading-[18px] flex-1">
          {description}
        </p>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-2 items-start">
      <p className="text-[13px] font-normal text-contrast/50 tracking-[-0.26px] leading-normal w-[212px]">
        Learn More
      </p>
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          {card}
        </a>
      ) : (
        <button
          type="button"
          className="text-left cursor-pointer"
          onClick={onClick}
        >
          {card}
        </button>
      )}
    </div>
  );
}
